import Input from "../../input";
import { DateTimeControlProps } from "../types";
import { parseDateValue } from "../utils";

export default function DateTimeControl(
  props: Readonly<Omit<DateTimeControlProps, "type">>,
) {
  const { value, onChange, getInputRef, ...rest } = props;
  return (
    <Input
      {...rest}
      ref={getInputRef}
      type="date"
      onChange={(e) => onChange?.(e.target.value)}
      value={parseDateValue(value)}
    />
  );
}
